// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// 3rd party imports
import notify from 'devextreme/ui/notify';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Constant imports
import { Constants } from '../../../../_constants/constants';
import { MessageInterval } from '../../../../_constants/messages-intervals';

// Service imports
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';
import { CashReceiptService } from '../../_services/cash-management/cash-receipt.service';

// Model imports
import { CashReceiptParametersDto } from '../../_models/cash-management/cash-receipts/cash-receipt-parameters-dto';
import { CashReceiptReverseParameterDto } from '../../_models/cash-management/cash-receipts/cash-receipt-reverse-parameter-dto';
import { ReverseEditorResultDto } from '../../../../shared-module/_models/reverse-editor-result-dto';

@Component({
    selector: 'app-cash-receipt-reverse-editor',
    templateUrl: './cash-receipt-reverse-editor.component.html',
    styleUrls: ['./cash-receipt-reverse-editor.component.scss']
})
export class CashReceiptReverseEditorComponent implements OnInit {
    @Input() visible = false;
    @Input() cashReceiptParams: CashReceiptParametersDto;

    @Output() onClose = new EventEmitter<boolean>();

    defaultLabelLocation = Constants.defaultFormLabelLocation;
    iconCancel = IconConstants.CANCEL;
    iconSave = IconConstants.SAVE;
    loadingVisible = false;

    editorResult = new ReverseEditorResultDto();

    constructor(
        private readonly errorService: ServerErrorService,
        private readonly cashReceiptService: CashReceiptService
    ) {}

    ngOnInit(): void {
        this.populateCashReceiptReverseEditor();
    }

    onShown(e: any): void {
        e.component.repaint();
    }

    onHidden(): void {
        this.visible = false;
        this.onClose.emit(false);
    }

    onSaveClick(): void {
        if (Utils.notNullAndDefined(this.editorResult.reverseDate)) {
            const params = new CashReceiptReverseParameterDto();
            params.managementCompanyId = this.cashReceiptParams.managementCompanyId;
            params.communityId = this.cashReceiptParams.communityId;
            params.cashReceiptId = this.cashReceiptParams.id;
            params.reverseDate = this.editorResult.reverseDate;
            this.loadingVisible = true;
            this.cashReceiptService.reverseCashReceipt(params).subscribe(
                (response: string) => {
                    notify(response, 'success', MessageInterval.successMsgInterval);
                    this.visible = false;
                    this.onClose.emit(true);
                    this.loadingVisible = false;
                },
                (error: HttpErrorResponse) => {
                    this.errorService.displayError(error);
                    this.loadingVisible = false;
                }
            );
        }
    }

    private populateCashReceiptReverseEditor(): void {
        this.loadingVisible = true;
        this.cashReceiptService.getReverseEditor(this.cashReceiptParams).subscribe(
            (result: ReverseEditorResultDto) => {
                this.editorResult = result;
                this.loadingVisible = false;
            },
            (error: HttpErrorResponse) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
                this.onHidden();
            }
        );
    }
}
